import React from 'react'
import { connect } from 'react-redux'
import { setVoucherCode } from '../../state/actions/smartySharedData'
import { getPlans } from '../../state/actions/plans'
import { doFetchGroupPlans } from '../../state/groupPlans/dispatchers'

import App from './App'

const mapStateToProps = ({
  smartySharedData: { voucherCode },
  plans,
  groupPlans,
  promotion: { promotion },
}) => ({
  voucherCode,
  plans,
  groupPlans,
  promo: promotion,
})

const mapDispatchToProps = (dispatch) => ({
  setVoucherCode: (voucherCode) => dispatch(setVoucherCode(voucherCode)),
  getPlans: () => {
    dispatch(getPlans())
  },
  doFetchGroupPlans: () => {
    dispatch(doFetchGroupPlans())
  },
})

const withApp = (Component) => {
  const addApp = (props) => (
    <App {...props}>
      <Component {...props} />
    </App>
  )
  return connect(mapStateToProps, mapDispatchToProps)(addApp)
}

export default withApp
